import { yupResolver } from '@hookform/resolvers/yup';

import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import { IApplicantFormMeta } from '@Shared/containers/form/applicant/ApplicantFormMeta';
import professionalInformationFormMeta from '@Shared/containers/form/applicant/professionalInformationFormMeta';
import salaryPerMonthFormMeta from '@Shared/containers/form/applicant/salaryFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IApplicantFormMeta,
} & TFormUIProps;

export default function ApplicantFormUI ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });
  
  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CustomFieldSet title={''}>
        <CC.SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IApplicantFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [],
            [...getFormFieldsName(professionalInformationFormMeta)]
          )}
        </CC.SimpleGrid>
      </CustomFieldSet>

      <CustomFieldSet title={'Information Professionnelle'}>
        <CC.SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IApplicantFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [...getFormFieldsName(professionalInformationFormMeta)],
            [...getFormFieldsName(salaryPerMonthFormMeta)]
          )}
        </CC.SimpleGrid>

        <CustomFieldSet title={'Salaire Par Mois'}>
          <CC.SimpleGrid
            columns={{ base: 1, lg: 2 }}
            gridRowGap={4}
            columnGap={10}
            my={4}
          >
            {displayCustomInputs<IApplicantFormMeta>(
              meta,
              register,
              errors,
              isLoading,
              [...getFormFieldsName(salaryPerMonthFormMeta)]
            )}
          </CC.SimpleGrid>
        </CustomFieldSet>
      </CustomFieldSet>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};
